//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { IHttpService, IPromise } from 'angular';
import { IPromiseService } from 'pinsights-js-shared';

const curalate = angular.module('curalate');

const BASE_URL_PIXEL = '/api/settings/pixel';
export interface ITrackingPixelDto {
  pixelId: number;
  isActive: boolean;
}

export class AnalyticsSettingsService {
  constructor(
    private readonly $http: IHttpService,
    private readonly PromiseService: IPromiseService,
  ) {}

  // Curalate Pixel
  public getPixel(): IPromise<ITrackingPixelDto> {
    return this.PromiseService.processHttpResponse(
      this.$http.get(BASE_URL_PIXEL),
    );
  }
}
curalate.service('AnalyticsSettingsService', [
  '$http',
  'PromiseService',
  AnalyticsSettingsService,
]);
